// Custom hook to fetch animals from Firestore
// Fetches active cows and buffalo for display on landing page

import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

export const useAnimals = (limit = 12) => {
  const [animals, setAnimals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnimals = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch active cows and buffalo
        const animalsRef = collection(db, 'animals');
        
        // Query for active animals (cows and buffalo)
        const q = query(
          animalsRef,
          where('status', '==', 'active')
        );

        const querySnapshot = await getDocs(q);
        const animalsData = [];

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const animalType = (data.animalType || data.type || '').toLowerCase();
          
          // Filter for cows and buffalo only
          if (animalType === 'cow' || animalType === 'buffalo') {
            // Get photo URL (prefer backCameraPhoto, then photoUrl, then first gallery image)
            let photoUrl = null;
            if (data.media?.backCameraPhoto) {
              photoUrl = data.media.backCameraPhoto;
            } else if (data.photoUrl) {
              photoUrl = data.photoUrl;
            } else if (data.media?.gallery && data.media.gallery.length > 0) {
              photoUrl = data.media.gallery[0];
            }

            animalsData.push({
              id: doc.id,
              name: data.name || data.animalName || 'Unnamed',
              animalId: data.animalId || doc.id,
              type: animalType,
              breed: data.breed || 'N/A',
              photoUrl: photoUrl,
              ageYears: data.ageYears || 0,
              ageMonths: data.ageMonths || 0
            });
          }
        });

        // Sort by name and limit
        animalsData.sort((a, b) => a.name.localeCompare(b.name));
        const limitedAnimals = animalsData.slice(0, limit);

        setAnimals(limitedAnimals);
      } catch (err) {
        console.error('Error fetching animals:', err);
        setError('Failed to load animals. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchAnimals();
  }, [limit]);

  return { animals, loading, error };
};

